import { useQuery } from "@tanstack/react-query";
import { getMyFeedback } from "@/lib/api";
import type { FeedbackBundle } from "@/lib/types";

/**
 * The `/api/my-feedback` bundle hook (M7) — one round-trip feeding
 * every `/feedback` list tab.
 *
 * NOT scope-keyed: the query key is the bare `["my-feedback"]`.
 * The backend resolves the viewer's team from the request scope
 * (`apiFetch` auto-injects `team_id` from the scope store), but
 * viewers have no scope *switcher* — scope doesn't change
 * mid-session, so it doesn't belong in the cache key. (M7
 * inventory Q2.) `useMe()` runs in the shell to reconcile
 * auth + scope before this fires.
 *
 * `enabled` is left default-on: a viewer with no resolved scope
 * gets a 401/409 surfaced as `query.error`, which the shell turns
 * into the inline login / "ask a coach" state — same pattern as
 * the coach surfaces.
 */
export function useMyFeedback() {
  return useQuery<FeedbackBundle>({
    queryKey: ["my-feedback"],
    queryFn: getMyFeedback,
  });
}
